<template>
  <div>
    <b-card :title="isEdit ? $t('settings.governorate.edit') : $t('settings.governorate.add')">
      <validation-observer
        ref="form"
        #default="{ handleSubmit }"
      >
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="name_ar"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.governorate.name_ar')"
                  label-for="name_ar"
                >
                  <b-form-input
                    id="name_ar"
                    v-model="form.name_ar"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="name_en"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.governorate.name_en')"
                  label-for="name_en"
                >
                  <b-form-input
                    id="name_en"
                    v-model="form.name_en"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="code"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.governorate.code')"
                  label-for="code"
                >
                  <b-form-input
                    id="code"
                    v-model="form.code"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <b-form-group :label="$t('settings.governorate.is_active')">
                <b-form-checkbox
                  v-model="form.is_active"
                  switch
                >
                  {{ form.is_active ? $t('common.active') : $t('common.inactive') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ $t('common.save') }}
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="$router.go(-1)"
              >
                {{ $t('common.cancel') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        name_ar: '',
        name_en: '',
        code: '',
        is_active: true,
      },
      required,
    }
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    },
  },
  mounted() {
    if (this.isEdit) {
      this.fetchGovernorate()
    }
  },
  methods: {
    fetchGovernorate() {
      this.$store.dispatch('governorates/get', this.$route.params.id)
        .then(response => {
          this.form = { ...response.data }
        })
    },
    onSubmit() {
      const action = this.isEdit ? 'update' : 'create'
      const payload = this.isEdit ? { id: this.$route.params.id, data: this.form } : this.form

      this.$store.dispatch(`governorates/${action}`, payload)
        .then(() => {
          this.$router.push({ name: 'settings-governorates' })
        })
    },
  },
}
</script>
